export default __webpack_public_path__ + "static/groups-ideas-bff-1-e68d6891555c6981e66d3ae1e3fd1f8b.jpg";